var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed bottom-5 left-5 z-50"},[_c('button',{staticClass:"px-2 ml-2 h-14 w-14 rounded-lg justify-center flex items-center",class:_vm.mapView ? 'bg-gray-800 bg-opacity-80' : 'bg-white bg-opacity-80 blur-md',on:{"click":function($event){return _vm.$emit('toggle')}}},[_c('img',{staticClass:"w-6 h-6",attrs:{"src":_vm.mapView == false
          ? require('@/assets/marker/mapstatus.svg')
          : require('@/assets/marker/mapstatus_white.svg')}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }